import { useMutation } from '@tanstack/react-query'
import { bulkShiftCreate } from 'api/shifts/bulkShiftCreate/bulkShiftCreate'
import {
  BulkShiftCreateErrorResponse,
  BulkShiftCreateRequest,
  BulkShiftCreateResponse,
} from 'api/shifts/bulkShiftCreate/types'

export const useBulkShiftCreateMutation = () => {
  return useMutation<
    BulkShiftCreateResponse,
    BulkShiftCreateErrorResponse,
    BulkShiftCreateRequest
  >({
    mutationFn: bulkShiftCreate,
  })
}
